import { Controller } from "@hotwired/stimulus"

// Fitxa comparativa: «Usa» copia el valor d'una font al camp del formulari.
export default class extends Controller {
  static targets = ["input"]

  copy(event) {
    const { field, value } = event.currentTarget.dataset
    const input = this.inputTargets.find((element) => element.dataset.field === field)
    if (!input) return
    input.value = value
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
